import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ac3165e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "legend-container" }
const _hoisted_2 = { class: "legend-label" }

import useLayerLegend from '@/composables/useLayerLegend';


export default /*#__PURE__*/_defineComponent({
  __name: 'LayerLegend',
  props: {
  url: {
    type: String,
    required: true,
  },
  showTitle: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;



const { legends } = useLayerLegend(props.url);

return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_el_text, {
      tab: "b",
      size: "large"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('legend')), 1)
      ]),
      _: 1
    }, 512), [
      [_vShow, __props.showTitle]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({ 'export-legend': __props.showTitle })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(legends), (panel) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "legend-wrap",
          key: panel.id
        }, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_text, {
              truncated: "",
              tag: "b"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(panel.name), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(panel.legends, (legend, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: legend?.title,
              class: _normalizeClass(["legend-item", { 'new-row': index % 2 === 0 }])
            }, [
              (legend?.color && !legend?.icon)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass({ 
              'legend-point-color': (!legend?.style || legend?.style == ''), 
              'legend-color': (legend?.style && legend?.style != '')
            }),
                    style: _normalizeStyle({ backgroundColor: legend?.color })
                  }, null, 6))
                : _createCommentVNode("", true),
              (legend?.icon)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "legend-icon",
                    style: _normalizeStyle({ backgroundImage: `url(${legend?.icon})` })
                  }, null, 4))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_2, _toDisplayString(legend?.title), 1)
            ], 2))
          }), 128))
        ]))
      }), 128))
    ], 2),
    _withDirectives(_createVNode(_component_el_empty, {
      description: _ctx.$t('Empty.Legend'),
      "image-size": 80
    }, null, 8, ["description"]), [
      [_vShow, _unref(legends).length === 0 && !__props.showTitle]
    ])
  ]))
}
}

})